import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";

import { loadCurrentOverview } from "./respondentsOverview";
import { loadSurveyResult } from "./surveyRunner";
import { loadSurveyVersion } from "./survey";
import rest from "../common/rest";
import { RespondentsOverviewModel as roModel } from "../common/entities";

const CHANGE_PROPERTY_ACTION = "STATUS_OF_SURVEY.CHANGE_PROPERTY_ACTION";
const LOAD_AVAILABLE_WORKFLOW_TRANSITION_ACTION = "RESPONDENT.LOAD_AVAILABLE_WORKFLOW_TRANSITION_ACTION";

export const SHOW_SEND_SURVEY_DIALOG = "showSendSurveyDialog";
export const SHOW_CHANGE_STATUS_SURVEY_DIALOG = "showChangeStatusSurveyDialog";
export const NEW_SURVEY_STATUS = "newSurveyStatus";
export const CHANGE_STATUS_SURVEY_CONFIRM_DIALOG = "changeStatusSurveyConfirmDialog";
export const TOTAL_PROGRESS = "totalProgress";
export const SENT = "SENT";
export const CLOSED = "CLOSED";
export const IN_PROGRESS = "IN_PROGRESS";
export const OBSOLETE = "OBSOLETE";
export const NEW = "NEW";
export const POSSIBLE_TRANSITIONS = "POSSIBLE_TRANSITIONS";
export const DISABLE_SENT_BUTTON = "disableSentButton";

const initialState = {
  [SHOW_SEND_SURVEY_DIALOG]: false,
  [SHOW_CHANGE_STATUS_SURVEY_DIALOG]: false,
  [CHANGE_STATUS_SURVEY_CONFIRM_DIALOG]: false,
  [DISABLE_SENT_BUTTON]: false
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case CHANGE_PROPERTY_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    case LOAD_AVAILABLE_WORKFLOW_TRANSITION_ACTION:
      newState = Object.assign({}, state, {
        [POSSIBLE_TRANSITIONS]: getStatus(action[PROPERTY_VALUE])
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}

export function changeStatusOfSurveyProperty(propetyName, propertyValue) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_NAME]: propetyName,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

function loadSuccessful(data, actionType) {
  return {
    [TYPE_KEY]: actionType,
    [PROPERTY_VALUE]: data
  };
}

/**
 * Function gets status links
 */
export function loadAvailableWorkflowTransition() {
  return (dispatch, getState) => {
    let currentOverview = getState().respondentsOverview.currentOverview;
    rest.doGet(`/survey/surveys/overviews/${currentOverview[roModel.reportPeriodGid]}/status/transitions`).then(
      (json) => {
        if (json.transitions) {
          dispatch(loadSuccessful(json.transitions, LOAD_AVAILABLE_WORKFLOW_TRANSITION_ACTION));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

function sendData(dispatch, currentOverview, sapToken, dialog, newStatus, pdf) {
  let overviewId = currentOverview[roModel.reportPeriodGid];
  let obj;
  dispatch(beginLoading());
  if (sapToken && pdf) {
    obj = JSON.stringify({
      sapToken: sapToken,
      pdfData: btoa(pdf)
    });
  }
  rest.doPut(`/survey/surveys/overviews/${overviewId}/status/${newStatus}`, obj).then(
    (json) => {
      if (json.status === 200) {
        dispatch(changeStatusOfSurveyProperty(dialog, false));
        dispatch(loadCurrentOverview(currentOverview[roModel.reportPeriodGid]));
        dispatch(loadSurveyResult(currentOverview[roModel.reportPeriodGid]));
        dispatch(loadAvailableWorkflowTransition());
        dispatch(endLoading());
      } else {
        dispatch(messagesReceived(createErrorMessages(json)));
        dispatch(endLoading());
      }
      dispatch(changeStatusOfSurveyProperty(DISABLE_SENT_BUTTON, false));
    },
    (reason) => {
      dispatch(messagesReceived(createBackendErrorMessages(reason)));
      dispatch(changeStatusOfSurveyProperty(DISABLE_SENT_BUTTON, false));
      dispatch(endLoading());
    }
  );
}

/**
 * Function sets new status of survey
 */
export function setNewStatusWorkflowTransition(newStatus, dialog) {
  return (dispatch, getState) => {
    if (newStatus === "SENT") {
      dispatch(changeStatusOfSurveyProperty(DISABLE_SENT_BUTTON, true));
    }
    let currentOverview = getState().respondentsOverview.currentOverview;
    let sapToken = getState().login.sap_token;
    if (!sapToken) {
      sendData(dispatch, currentOverview, sapToken, dialog, newStatus, null);
    } else {
      dispatch(
        loadSurveyVersion(currentOverview, currentOverview, false, false, false, true, (pdf) => {
          sendData(dispatch, currentOverview, sapToken, dialog, newStatus, pdf);
        })
      );
    }
  };
}

export function getStatus(workflowStatuses) {
  let statusAvailable = [];
  for (let i = 0; i < workflowStatuses.length; i++) {
    let status = workflowStatuses[i].nextStatus;
    statusAvailable[status] = true;
  }
  return statusAvailable;
}
